
import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useToast } from '@/hooks/use-toast';

interface ProtectedRouteProps {
  children: React.ReactNode;
  roles?: string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, roles }) => {
  const location = useLocation();
  const { toast } = useToast();
  const [user, setUser] = useState<any | null>(null);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const raw = localStorage.getItem('user_session');
    if (raw) {
      try {
        const parsed = JSON.parse(raw);
        setUser(parsed);
      } catch {
        localStorage.removeItem('user_session');
      }
    }
    setIsLoaded(true);
  }, []);

        // Fix This Hardcoded setup ** **

  const isAuthenticated = true;

  // ⏳ Wait until session check is done
  if (!isLoaded) return null;

  // 🚫 Not authenticated
  if (!isAuthenticated) {
    toast({
      title: 'Authentication Required',
      description: 'Please log in to access this page.',
      variant: 'destructive',
    });
    return <Navigate to="/auth" state={{ from: location }} replace />;
  }

  // 🔒 Authenticated but unauthorized
  if (roles && roles.length > 0 && (!user?.role || !roles.includes(user.role))) {
    toast({
      title: 'Access Denied',
      description: 'You do not have permission to access this page.',
      variant: 'destructive',
    });
    // return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
